// Every server call the editor makes, behind one context: the real staff API
// client (../api) by default, stubs in the dev harness (PageEditorHarness),
// so the whole editor runs with no server.
import { createContext, useContext } from 'react';
import * as api from '../api';

export type CrmFormFull = api.CrmFormFull;

export interface EditorApi {
  getPage: typeof api.getPage;
  updatePage: typeof api.updatePage;
  publishPage: typeof api.publishPage;
  unpublishPage: typeof api.unpublishPage;
  slugAvailable: typeof api.slugAvailable;
  ensurePreviewToken: typeof api.ensurePreviewToken;
  listVersions: typeof api.listVersions;
  saveVersion: typeof api.saveVersion;
  pageStats: typeof api.pageStats;
  pageDaily: typeof api.pageDaily;
  pageSources: typeof api.pageSources;
  listPageTrackingSites: typeof api.listPageTrackingSites;
  aiEditSections: typeof api.aiEditSections;
  saveTemplate: typeof api.saveTemplate;
  uploadPageImage: typeof api.uploadPageImage;
  listDomains: typeof api.listDomains;
  setDomainRoot: typeof api.setDomainRoot;
  listCrmForms: typeof api.listCrmForms;
  createCrmForm: typeof api.createCrmForm;
  listCrmCalendars: typeof api.listCrmCalendars;
  getCrmForm: typeof api.getCrmForm;
}

/** The real calls, read from the module at call time (so test mocks of ../api apply). */
export const realEditorApi: EditorApi = {
  getPage: (...a) => api.getPage(...a),
  updatePage: (...a) => api.updatePage(...a),
  publishPage: (...a) => api.publishPage(...a),
  unpublishPage: (...a) => api.unpublishPage(...a),
  slugAvailable: (...a) => api.slugAvailable(...a),
  ensurePreviewToken: (...a) => api.ensurePreviewToken(...a),
  listVersions: (...a) => api.listVersions(...a),
  saveVersion: (...a) => api.saveVersion(...a),
  pageStats: (...a) => api.pageStats(...a),
  pageDaily: (...a) => api.pageDaily(...a),
  pageSources: (...a) => api.pageSources(...a),
  listPageTrackingSites: (...a) => api.listPageTrackingSites(...a),
  aiEditSections: (...a) => api.aiEditSections(...a),
  saveTemplate: (...a) => api.saveTemplate(...a),
  uploadPageImage: (...a) => api.uploadPageImage(...a),
  listDomains: (...a) => api.listDomains(...a),
  setDomainRoot: (...a) => api.setDomainRoot(...a),
  listCrmForms: (...a) => api.listCrmForms(...a),
  createCrmForm: (...a) => api.createCrmForm(...a),
  listCrmCalendars: (...a) => api.listCrmCalendars(...a),
  getCrmForm: (...a) => api.getCrmForm(...a),
};

export const EditorApiContext = createContext<EditorApi>(realEditorApi);

export function useEditorApi(): EditorApi {
  return useContext(EditorApiContext);
}
